module.exports = __webpack_public_path__ + "img/118.b99ff696.jpg";